import { DlcoTestAcceptabilitySummary, TestResults } from "../../PulmonaryFunctionTests/Shared/PFTAPITypes";
import { ParameterTypeName } from "../../misc/api/ParameterTypes";

declare let rootUrl: string;

export function MapDlcoTestAcceptabilitySummaries(testResults: TestResults[]): Array<DlcoTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            TestId: tr.TestId,
            Accepted: tr.OverreaderAcceptability,
            Dlco: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_DLCO).Value,
            DlcoCorr: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_DLCO_CORR).Value,
            BHT: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_BHT).Value,
            IV: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_IV).Value,
            KCO: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_KCO).Value,
            VA: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_VA).Value
        } as DlcoTestAcceptabilitySummary;
    });
}
